import React, { useState, useEffect, useContext } from "react";
import { dangerIcon, calendarIcon, calendarWhiteIcon } from "assets/img";
import Rangeslider from "components/rangeSlider";
import MyCalendar from "components/calendar";
import ActiveStepIndicator from "components/shared/activeStepIndicator";
import { weekDays, dateRange } from "utils/constants/onboardingStep";
import { MobXProviderContext } from "mobx-react";
import { monthNames } from "utils/constants/onboardingStep";
import { useEarliestDate } from "components/hooks/useEarliestDate";
import classNames from "classnames";
import ErrorAlert from "components/Alerts/ErrorAlert";
import { InfoButtonGray } from "assets/img";
import { preventMinus } from "utils/helpers/validation";
import Alert from "components/Alerts/Alert";

const Step3 = ({ disableButton }) => {
  const { onboardingStore } = useContext(MobXProviderContext);
  const subsidyErrors = onboardingStore.subsidyErrors;

  const selectedMeal = onboardingStore?.selectedMealArray?.meal_name;
  const [mealDeliveryOption, setMealDeliveryOption] = useState(
    onboardingStore.enable_meal_delivery || "every week"
  );
  const [mealRecievingDays, setMealRecievingDays] = useState(
    onboardingStore.recieving_days || []
  );
  const [mealStartDate, setMealStartDate] = useState(
    onboardingStore.isNotSureSelected
      ? "I am not sure yet"
      : onboardingStore.default_date !== ""
      ? "select date"
      : ""
  );

  const currentMonthIndex = new Date().getMonth();
  const nextMonthIndex = (currentMonthIndex + 1) % 12;
  const nextNextMonthIndex = (currentMonthIndex + 2) % 12;

  const currentMonthName = monthNames[currentMonthIndex];
  const nextMonthName = monthNames[nextMonthIndex];
  const nextNextMonthName = monthNames[nextNextMonthIndex];

  const initialMealSelectedDates = [
    { [currentMonthName]: [] },
    { [nextMonthName]: [] },
    { [nextNextMonthName]: [] },
  ];

  const normalizeMealSelectedDates = (existingDates = []) => {
    const defaultMonths = [currentMonthName, nextMonthName, nextNextMonthName];

    return defaultMonths?.map((monthName) => {
      const found = existingDates?.find(
        (entry) =>
          entry && Object.prototype.hasOwnProperty.call(entry, monthName)
      );
      return found || { [monthName]: [] };
    });
  };

  const [mealSelectedDates, setMealSelectedDates] = useState(() =>
    normalizeMealSelectedDates(
      onboardingStore.recieving_dates || initialMealSelectedDates
    )
  );

  let [
    mealSelectedDatesMonth1,
    mealSelectedDatesMonth2,
    mealSelectedDatesMonth3,
  ] = mealSelectedDates;

  const [defaultDate, setDefaultDate] = useState(
    onboardingStore.default_date || ""
  );
  const [selectDateHover, setSelectDateHover] = useState(false);
  const [isRendered, setIsRendered] = useState(false);
  const [mealAllowanceType, setMealAllowanceType] = useState(
    onboardingStore.meal_allowance_type || "daily"
  );
  const [mealAllowanceValue, setMealAllowanceValue] = useState(
    onboardingStore.meal_allowance_value || 0
  );
  const [enableOverpayment, setEnableOverpayment] = useState(
    onboardingStore.enable_overpayment
  );
  const [showCalendar, setShowCalendar] = useState(
    mealStartDate !== "" && mealStartDate?.toLowerCase() !== "i am not sure yet"
  );
  const [showMobileCalendar, setShowMobileCalendar] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [defaultSubsidy, setDefaultSubsidy] = useState(
    onboardingStore.meal_plan_subsidy || 100
  );

  const allDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const [dailySubsidy, setDailySubsidy] = useState(() =>
    allDays.reduce((acc, day) => {
      acc[day] = "";
      return acc;
    }, {})
  );
  const [errors, setErrors] = useState({});

  let { earliestDate } = useEarliestDate();
  const [isVisible, setIsVisible] = useState(onboardingStore.dateError);
  const [dateErrorMessage, setDateErrorMessage] = useState(
    onboardingStore.dateErrorMessage
  );

  useEffect(() => {
    setIsVisible(onboardingStore.dateError);
    setDateErrorMessage(onboardingStore.dateErrorMessage);
  }, [onboardingStore.dateError, onboardingStore.dateErrorMessage]);

  useEffect(() => {
    disableButton(true);
  }, []);

  useEffect(() => {
    if (mealAllowanceValue === 0) {
      const allowance =
        mealAllowanceType?.toLocaleLowerCase() === "daily" ? 20 : 100;
      handleMealAllowance(allowance);
    }
  }, [mealAllowanceType, mealAllowanceValue]);

  useEffect(() => {
    if (mealDeliveryOption?.toLowerCase() == "every week") {
      const dailySubsidy = onboardingStore.dailySubsidyOverride || {};

      const allDaysHaveValue =
        mealRecievingDays.length > 0 &&
        mealRecievingDays.every(
          (day) => dailySubsidy?.[day] !== undefined && dailySubsidy[day] !== ""
        );
      if (mealRecievingDays.length == 0) return;
      if (mealStartDate == "select date" && !defaultDate) return;
      if (
        mealStartDate !== "select date" &&
        mealStartDate !== "I am not sure yet"
      )
        return;
      if (
        mealRecievingDays.length > 0 &&
        !allDaysHaveValue &&
        mealAllowanceType == "daily"
      )
        return;

      disableButton(false);
    } else {
      const allEmpty = mealSelectedDates?.every((month) => {
        return month && Object.values(month)[0]?.length == 0;
      });
      if (allEmpty) {
        disableButton(true);
        return;
      } else disableButton(false);
    }
  }, [
    mealAllowanceValue,
    mealDeliveryOption,
    mealSelectedDates,
    mealRecievingDays,
    mealAllowanceType,
    mealStartDate,
    disableButton,
    defaultDate,
    onboardingStore.dailySubsidyOverride,
  ]);

  useEffect(() => {
    let isEveryWeekSelected = false;
    let selectedEarliestDate = earliestDate(mealSelectedDates);

    if (mealDeliveryOption?.toLowerCase() == "i will set my own dates") {
      isEveryWeekSelected = false;
    } else if (mealDeliveryOption?.toLowerCase() == "every week") {
      isEveryWeekSelected = true;
    }
    onboardingStore.handleMealSeriesAndSubsidiesData(
      isEveryWeekSelected ? mealRecievingDays : [],
      isEveryWeekSelected
        ? mealStartDate == "select date"
          ? defaultDate
          : mealStartDate
        : selectedEarliestDate,
      !isEveryWeekSelected ? mealSelectedDates : [],
      mealAllowanceType,
      mealAllowanceValue,
      enableOverpayment,
      mealDeliveryOption,
      defaultSubsidy
    );
  }, [
    onboardingStore,
    mealRecievingDays,
    mealStartDate,
    mealSelectedDates,
    mealAllowanceType,
    mealAllowanceValue,
    enableOverpayment,
    mealDeliveryOption,
    earliestDate,
    defaultDate,
  ]);

  const handleRecievingDaysClick = (value) => {
    if (mealRecievingDays?.includes(value)) {
      setMealRecievingDays((prevDays) =>
        prevDays.filter((day) => day !== value)
      );
    } else {
      setMealRecievingDays((prevDays) => [...prevDays, value]);
    }
  };

  const handleMealAllowance = (value) => {
    setMealAllowanceValue(value);
  };

  const handleMealAllowanceType = (value) => {
    setMealAllowanceType(value);
    if (value?.toLowerCase() === "daily") {
      setMealAllowanceValue(20);
    } else if (value?.toLowerCase() === "weekly") {
      setMealAllowanceValue(100);
    } else {
      setMealAllowanceValue(0);
    }
  };

  const handleMultipleDateChange = (calendarKey, newDate) => {
    const updatedMonthsArray = [...mealSelectedDates];

    const selectedMonthIndex = newDate?.[0]?.month?.number - 1;
    const selectedMonthName = monthNames[selectedMonthIndex];

    if (newDate?.length > 0) {
      updatedMonthsArray[calendarKey - 1] = {
        [selectedMonthName]: newDate.map(
          (date) => `${date.day}-${date.month.number}-${date.year}`
        ),
      };
    } else {
      const existingMonth =
        Object.keys(updatedMonthsArray[calendarKey - 1] || {})[0] ||
        monthNames[(new Date().getMonth() + calendarKey - 1) % 12];

      updatedMonthsArray[calendarKey - 1] = {
        [existingMonth]: [],
      };
    }

    setMealSelectedDates(normalizeMealSelectedDates(updatedMonthsArray));
  };

  const handleDateChange = (value) => {
    const parsedDate = new Date(value);
    setDefaultDate(
      parsedDate.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    );

    if (
      (!isNaN(parsedDate.getTime()) &&
        parsedDate < dateRange?.minSelectableDate) ||
      parsedDate > dateRange?.maxSelectableDate
    ) {
      setErrorMessage({
        title: "Invalid Date Selection",
        body: `The selected date is earlier than the minimum selectable date. Please choose a date after ${dateRange?.minSelectableDate.toLocaleDateString()}.`,
      });

      setDefaultDate("");
      setTimeout(() => {
        setShowError(true);
      }, 2000);
      return;
    }
    setMealAllowanceType("daily");
    setMealAllowanceValue(20);
  };

  useEffect(() => {
    [
      mealSelectedDatesMonth1,
      mealSelectedDatesMonth2,
      mealSelectedDatesMonth3,
    ] = mealSelectedDates;

    setIsRendered((prev) => !prev);
  }, [mealSelectedDates]);

  const handleModalOpen = (value) => {
    setOpenModal(value);
  };

  const afterCloseCallBack = () => {
    setShowError(false);
    setErrorMessage("");
    setShowMobileCalendar(false);
  };

  const onChangeDaily = (value, day) => {
    onboardingStore.setDailySubsidyOverride({ [day]: value });
    if (value !== "") {
      const updatedErrors = { ...onboardingStore.subsidyErrors };
      delete updatedErrors[day];
      onboardingStore.setErrors(updatedErrors);
    }
    setErrors((prev) => ({ ...prev, [day]: false }));
  };

  const isDayEnabled = (day) => mealRecievingDays?.includes(day);

  return (
    <>
      <ActiveStepIndicator step={3} />

      <ErrorAlert
        visible={showError}
        errorMessage={errorMessage}
        dismissAlert={afterCloseCallBack}
      />

      {isVisible && (
        <Alert
          visible={isVisible}
          errorMessage={dateErrorMessage}
          dismissAlert={() => {
            setIsVisible(false);
            setDateErrorMessage("");
          }}
        />
      )}

      <div className="flex-col flex gap-6">
        <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
          How often do you want to enable {selectedMeal} delivery?
        </div>

        <div className="mb-0.5 w-full screen-xs:w-full-215">
          <div className="screen-lg:flex flex-wrap screen-md:flex flex-wrap">
            <div
              className={`screen-lg:mr-3 screen-md:mr-3 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] ${
                mealDeliveryOption?.toLowerCase() === "every week"
                  ? "bg-indigo-500 text-white "
                  : "bg-slate-50 hover:bg-indigo-500 hover:text-white "
              } rounded-3xl justify-center gap-2 flex`}
              onClick={() => {
                disableButton(true);
                setShowCalendar(false);
                setMealDeliveryOption("every week");
                setMealRecievingDays([]);
                setMealStartDate("");
                setMealAllowanceType("daily");
                setDefaultDate("");
                setShowMobileCalendar(false);
              }}
            >
              Every week
            </div>

            <div
              className={`screen-lg:mr-3 screen-md:mr-3 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] ${
                mealDeliveryOption?.toLowerCase() === "i will set my own dates"
                  ? "bg-indigo-500 text-white "
                  : "bg-slate-50 hover:bg-indigo-500 hover:text-white "
              } rounded-3xl justify-center gap-2 flex`}
              onClick={() => {
                disableButton(true);
                setShowCalendar(false);
                setMealDeliveryOption("i will set my own dates");
                setMealAllowanceType("daily");
                setMealSelectedDates([]);
                setDefaultDate("");
                setDailySubsidy({
                  monday: "",
                  tuesday: "",
                  wednesday: "",
                  thursday: "",
                  friday: "",
                  saturday: "",
                  sunday: "",
                });
              }}
            >
              I will set my own dates
            </div>
          </div>
        </div>

        {mealDeliveryOption?.toLowerCase() == "every week" && (
          <>
            <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
              On what day(s) would you like to receive meals?
            </div>

            <div className="mb-0.5 w-full screen-xs:w-full-215">
              <div className="flex flex-wrap gap-x-3 gap-y-4">
                {weekDays?.map((value, index) => (
                  <div
                    key={index}
                    className={`px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] capitalize ${
                      mealRecievingDays?.includes(value)
                        ? "bg-indigo-500 text-white"
                        : "bg-slate-50 hover:bg-indigo-500 hover:text-white"
                    } rounded-3xl justify-center gap-2 flex`}
                    onClick={() => handleRecievingDaysClick(value)}
                  >
                    {value}
                  </div>
                ))}
              </div>
            </div>

            <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
              When would you like to start?
            </div>

            <div className="mb-0.5 w-full">
              <div className="screen-lg:flex flex-wrap screen-md:flex flex-wrap">
                <div
                  className={classNames(
                    "hidden screen-lg:flex screen-md:flex screen-lg:w-36 screen-md:w-36 h-12 screen-lg:mr-3 screen-md:mr-3 mt-4 px-4 py-3 rounded-3xl items-center justify-between cursor-pointer gap-2",
                    {
                      "bg-indigo-500 text-white ":
                        mealStartDate == "select date",
                      "bg-slate-50 text-slate-700 hover:bg-indigo-500 hover:text-white ":
                        mealStartDate !== "select date",
                    }
                  )}
                  onClick={() => {
                    setMealStartDate("select date");
                    setShowCalendar(true);
                  }}
                  onMouseEnter={() => setSelectDateHover(true)}
                  onMouseLeave={() => setSelectDateHover(false)}
                >
                  Select date
                  <span>
                    <img
                      className="w-[20px] h-[20px] "
                      src={
                        mealStartDate == "select date" || selectDateHover
                          ? calendarWhiteIcon
                          : calendarIcon
                      }
                      alt="CalendarIcon"
                    />
                  </span>
                </div>
                <div
                  className={classNames(
                    "screen-lg:hidden screen-md:hidden flex h-12 mt-4 px-4 py-3 rounded-xl items-center justify-between cursor-pointer gap-2 bg-slate-50 text-slate-700"
                  )}
                  onClick={() => {
                    setMealStartDate("select date");
                    setShowCalendar(false);
                    setShowMobileCalendar(true);
                    setOpenModal(true);
                    setIsRendered((prev) => !prev);
                  }}
                  onMouseEnter={() => setSelectDateHover(true)}
                  onMouseLeave={() => setSelectDateHover(false)}
                >
                  {defaultDate !== "" &&
                  defaultDate?.toLowerCase() !== "invalid date"
                    ? defaultDate
                    : "Select date"}
                  <span>
                    <img
                      className="w-[20px] h-[20px] "
                      src={calendarIcon}
                      alt="CalendarIcon"
                    />
                  </span>
                </div>

                <div
                  className={`screen-lg:w-40 screen-md:w-40 h-12 screen-lg:mr-3 screen-md:mr-3 mt-4 px-4 py-3 hover:cursor-pointer text-indigo-500 font-inter-medium text-sm leading-[14px] ${
                    mealStartDate?.toLowerCase() === "i am not sure yet"
                      ? "bg-indigo-500 text-white "
                      : "bg-slate-50 hover:bg-indigo-500 hover:text-white "
                  } screen-lg:rounded-3xl screen-md:rounded-3xl rounded-xl items-center justify-center gap-2 flex`}
                  onClick={() => {
                    setShowCalendar(false);
                    setShowMobileCalendar(false);
                    setMealStartDate("I am not sure yet");
                    setDefaultDate("");
                  }}
                >
                  I am not sure yet
                </div>
              </div>
            </div>
          </>
        )}

        {showMobileCalendar &&
          mealDeliveryOption?.toLowerCase() === "every week" && (
            <MyCalendar
              handleDatePicker={handleDateChange}
              selectedValue={defaultDate}
              showModal={openModal}
              openModal={true}
              setModal={handleModalOpen}
              isRendered={isRendered}
              Step3={true}
            />
          )}

        {showCalendar && mealDeliveryOption?.toLowerCase() === "every week" && (
          <div className="hidden screen-lg:flex screen-md:flex inline-flex gap-5 overflow-x-auto">
            <MyCalendar
              highlightToday={false}
              disableMonthYearPicker={true}
              isMultiple={false}
              showButtons={false}
              handleDatePicker={handleDateChange}
              value={1}
              selectedValue={defaultDate}
              isRendered={isRendered}
            />
          </div>
        )}

        {mealDeliveryOption?.toLowerCase() === "i will set my own dates" && (
          <div className="flex inline-flex gap-5 overflow-x-auto z-0">
            <MyCalendar
              highlightToday={false}
              disableMonthYearPicker={true}
              isMultiple={true}
              showButtons={false}
              handleMultipleDates={(dates) =>
                handleMultipleDateChange(1, dates)
              }
              value={1}
              multipleValues={mealSelectedDatesMonth1}
              isRendered={isRendered}
              isOwnDates={true}
            />

            <MyCalendar
              highlightToday={false}
              disableMonthYearPicker={true}
              isMultiple={true}
              showButtons={false}
              handleMultipleDates={(dates) =>
                handleMultipleDateChange(2, dates)
              }
              value={2}
              multipleValues={mealSelectedDatesMonth2}
              isRendered={isRendered}
              isOwnDates={true}
            />

            <MyCalendar
              highlightToday={false}
              disableMonthYearPicker={true}
              isMultiple={true}
              showButtons={false}
              handleMultipleDates={(dates) =>
                handleMultipleDateChange(3, dates)
              }
              value={3}
              multipleValues={mealSelectedDatesMonth3}
              isRendered={isRendered}
              isOwnDates={true}
            />
          </div>
        )}

        {mealDeliveryOption?.toLowerCase() === "every week" && (
          <>
            <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
              Meal Plan Subsidy
            </div>

            <div className="d-row mb-[16px]">
              <button
                className={`screen-lg:mr-3 screen-md:mr-3 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] ${
                  mealAllowanceType?.toLowerCase() === "daily"
                    ? "bg-indigo-500 text-white "
                    : "bg-slate-50 hover:bg-indigo-500 hover:text-white"
                } rounded-3xl justify-center gap-2 flex`}
                onClick={() => {
                  handleMealAllowanceType("daily");

                  setDailySubsidy({
                    monday: "",
                    tuesday: "",
                    wednesday: "",
                    thursday: "",
                    friday: "",
                    saturday: "",
                    sunday: "",
                  });
                  onboardingStore.setErrors({});
                }}
              >
                Per Meal
              </button>

              <button
                className={`screen-lg:mr-3 screen-md:mr-3 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] ${
                  mealAllowanceType?.toLowerCase() === "weekly"
                    ? "bg-indigo-500 text-white "
                    : "bg-slate-50 hover:bg-indigo-500 hover:text-white "
                } rounded-3xl justify-center gap-2 flex`}
                onClick={() => {
                  handleMealAllowanceType("weekly");

                  onboardingStore.setErrors({});
                }}
              >
                Weekly
              </button>
            </div>

            {mealAllowanceType?.toLowerCase() == "daily" ? (
              <small className="text-[#566985] font-inter-regular text-[14px]">
                Setting a per meal subsidy allows users to use this amount for
                each meal. To exclude a specific day, enter 0 for that day. You
                can also assign custom subsidies to individual users, but for
                now, start by setting the default per meal subsidy.
              </small>
            ) : (
              <small className="text-[#566985] font-inter-regular text-[14px]">
                Users can spend their weekly subsidy across multiple days and it
                may run out before the week ends. Weekly subsidies reset every
                Monday at 12 AM.
              </small>
            )}

            {mealAllowanceType?.toLowerCase() == "daily" ? (
              <div className="d-col bg-[#F7F9FF] p-[12px] rounded-lg">
                <div className="grid grid-cols-3 screen-lg:grid-cols-7 gap-4 py-[12px] px-[10px]">
                  {allDays.map((day) => {
                    const disabled = !isDayEnabled(day);

                    return (
                      <div key={day} className="text-center rounded">
                        <span className="text-sm font-inter-medium text-gray-700 capitalize">
                          {day.slice(0, 3)}
                        </span>

                        <div
                          className={classNames(
                            "d-row px-[14px] py-[7px] mt-[7px] rounded-xl items-center",
                            disabled
                              ? "bg-[#E4E5EA]"
                              : subsidyErrors?.[day]
                              ? "bg-white border border-red-500"
                              : "bg-white"
                          )}
                        >
                          {!disabled ? (
                            <>
                              <small
                                className={`text-[13px] font-inter-medium ${
                                  onboardingStore.dailySubsidyOverride[day]
                                    ? "text-black"
                                    : "text-gray-400"
                                }`}
                              >
                                $
                              </small>

                              <input
                                disabled={false}
                                className="w-full text-[13px] font-inter-medium focus:outline-none h-[40px] text-black"
                                type="number"
                                placeholder="0.00"
                                value={
                                  onboardingStore.dailySubsidyOverride[day]
                                }
                                onChange={(e) => {
                                  onChangeDaily(e.target.value, day);
                                }}
                                onWheelCapture={(e) => {
                                  e.target.blur();
                                }}
                                onKeyPress={preventMinus}
                                onBlur={(e) => {
                                  const roundedValue = parseFloat(
                                    e.target.value
                                  ).toFixed(2);
                                  if (!isNaN(roundedValue)) {
                                    onChangeDaily(roundedValue, day);
                                  }
                                }}
                                onKeyDown={(e) => {
                                  const value = parseFloat(e.target.value) || 0;

                                  if (
                                    e.code === "Minus" ||
                                    e.key === "-" ||
                                    e.keyCode === 189
                                  ) {
                                    e.preventDefault();
                                  }

                                  if (e.code === "ArrowDown" && value <= 0) {
                                    e.preventDefault(); // prevent negative values
                                  }
                                }}
                              />
                            </>
                          ) : (
                            <div className="w-full h-[40px]"></div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="screen-lg:w-[541px] screen-md:w-[541px] w-full  px-2 py-4 bg-slate-50 rounded-lg flex-col justify-start items-start gap-2.5 inline-flex">
                <div className="text-slate-700 text-lg font-inter-semibold leading-tight">
                  Weekly Allowance Per Person
                </div>

                <div className="hidden screen-lg:flex screen-md:flex screen-sm:hidden w-full screen-lg:w-[512px] screen-md:w-[512px] justify-between items-center gap-6 inline-flex">
                  <div className="text-slate-700 text-base font-inter-normal leading-7">
                    $0
                  </div>

                  <Rangeslider
                    minValue={0}
                    maxValue={
                      mealAllowanceType?.toLowerCase() === "daily"
                        ? "50"
                        : "200"
                    }
                    currentValue={mealAllowanceValue}
                    setMealAllowance={handleMealAllowance}
                  />

                  <div className="text-slate-700 text-base font-inter-normal leading-7">
                    {mealAllowanceType?.toLowerCase() === "daily"
                      ? "$50"
                      : "$200"}
                  </div>
                </div>

                <div className="screen-lg:w-[512px] screen-md:w-[512px] w-full flex-col gap-1 flex">
                  <div className="h-[46px] rounded-xl mb-2 bg-white">
                    <span className="ml-4 text-slate-700 font-inter-medium">
                      $
                    </span>

                    <input
                      type="text"
                      id="otherMeal"
                      value={mealAllowanceValue}
                      min={0}
                      max={
                        mealAllowanceType?.toLowerCase() === "daily" ? 50 : 200
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^[0-9]*\.?[0-9]*$/;
                        if (regex.test(value)) {
                          const maxValue =
                            mealAllowanceType?.toLowerCase() === "daily"
                              ? 50
                              : 200;
                          if (value >= 0 && value <= maxValue) {
                            handleMealAllowance(value);
                          } else handleMealAllowance(mealAllowanceValue);
                        }
                      }}
                      className="w-4/5 h-[42px] pl-0 p-4 rounded-xl text-base font-inter-medium leading-7 text-slate-700 outline-none"
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {mealDeliveryOption?.toLowerCase() == "i will set my own dates" && (
          <>
            <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
              Meal Plan Subsidy
            </div>

            <div className="text-slate-500 font-inter-normal text-base w-[654px]">
              Setting a per meal subsidy allows users to use this amount for
              each meal. You can also assign custom subsidies to individual
              users, but for now, start by setting the default per meal subsidy.
              This subsidy will apply to all current and future meals created
              for this meal plan.
            </div>

            <div className="screen-lg:w-[541px] screen-md:w-[541px] w-full  px-2 py-4 bg-slate-50 rounded-lg flex-col justify-start items-start gap-2.5 inline-flex">
              <div className="hidden screen-lg:flex screen-md:flex screen-sm:hidden w-full screen-lg:w-[512px] screen-md:w-[512px] justify-between items-center gap-6 inline-flex">
                <div className="text-slate-700 text-base font-inter-normal leading-7">
                  $0
                </div>

                <Rangeslider
                  minValue={0}
                  maxValue={200}
                  currentValue={defaultSubsidy}
                  setMealAllowance={setDefaultSubsidy}
                />

                <div className="text-slate-700 text-base font-inter-normal leading-7">
                  $200
                </div>
              </div>

              <div className="screen-lg:w-[512px] screen-md:w-[512px] w-full flex-col gap-1 flex">
                <div className="h-[46px] rounded-xl mb-2 bg-white">
                  <span className="ml-4 text-slate-700 font-inter-medium">
                    $
                  </span>

                  <input
                    type="text"
                    id="otherMeal"
                    value={defaultSubsidy}
                    placeholder="0.00"
                    min={0}
                    max={200}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^[0-9]*\.?[0-9]*$/;
                      if (regex.test(value)) {
                        if (value >= 0 && value <= 200)
                          setDefaultSubsidy(value);
                      }
                    }}
                    className="h-[42px] w-1/2 pl-0 p-4 rounded-xl text-base font-inter-medium leading-7 text-slate-700 outline-none"
                  />
                </div>
              </div>
            </div>
          </>
        )}

        <div className="flex-col justify-start items-start gap-[7px] mb-[12px] mt-[246x] flex">
          <label className="relative flex flex-wrap items-center cursor-pointer gap-2.5">
            <input
              type="checkbox"
              checked={enableOverpayment}
              className="sr-only peer"
              onChange={(e) => setEnableOverpayment(e.target.checked)}
            />

            <div className="w-9 h-5 p-0.5 bg-gray-200 rounded-full peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:start-[2px] after:bg-white after:w-4 after:h-4 after:shadow after:border after:rounded-full after:transition-all  peer-checked:bg-indigo-500"></div>

            <span className="text-[#2D3958] text-[14px] font-inter-medium leading-none">
              Overpayment
            </span>
          </label>

          <div className="justify-start items-start gap-1 mt-[14px] inline-flex">
            <img src={InfoButtonGray} className="w-3 h-3" alt="DangerIcon" />

            <div className="w-full text-[#566985] text-[12px] font-inter-regular leading-none w-[654px]">
              Allow users to use their personal credit card when going over set
              allowance to change your settings, please contact your hungerhub
              account admin.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step3;
